import { isDebug } from '@/config';

const STYLE = 'color:#8b9cff;font-weight:600';

/** Small namespaced logger. `debug` output is gated behind debug mode. */
export function createLogger(scope: string) {
  const tag = `%c[orvae:${scope}]`;
  return {
    info: (...args: unknown[]) => console.info(tag, STYLE, ...args),
    warn: (...args: unknown[]) => console.warn(tag, STYLE, ...args),
    error: (...args: unknown[]) => console.error(tag, STYLE, ...args),
    debug: (...args: unknown[]) => {
      if (isDebug) console.log(tag, STYLE, ...args);
    },
    group: (label: string) => console.group(`%c[orvae:${scope}]%c ${label}`, STYLE, ''),
    groupEnd: () => console.groupEnd(),
  };
}

export type Logger = ReturnType<typeof createLogger>;
